import React, { useCallback, useRef, useState } from "react";
import styled from "styled-components";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import useMeasure from "react-use-measure";
import useDesktopDetection from "components/hooks/useDesktopDetection";
import { pdfDocumentOptions } from "utils/pdfWorkerSetup";

function PDF({ file, scale, onDocumentLoaded, onPagesLoaded, renderBottom }) {
  const pdfContainerRef = useRef();
  const [setPdfContainerMeasureRef, pdfContainerRect] = useMeasure({ polyfill: ResizeObserver });
  const [numPages, setNumPages] = useState(null);
  const isDesktop = useDesktopDetection("lg");
  const renderedPagesRef = useRef(0);

  const onDocumentLoadSuccess = useCallback(
    ({ numPages }) => {
      setNumPages(numPages);

      if (onDocumentLoaded) {
        onDocumentLoaded();
      }
    },
    [onDocumentLoaded]
  );

  const onPageRenderSuccess = useCallback(() => {
    renderedPagesRef.current += 1;

    if (renderedPagesRef.current === numPages) {
      if (onPagesLoaded) {
        setTimeout(() => {
          onPagesLoaded();
        }, 0);
      }
    }
  }, [numPages, onPagesLoaded]);

  if (!file) return null;

  return (
    <PDFStyled
      ref={(node) => {
        pdfContainerRef.current = node;
        setPdfContainerMeasureRef(node);
      }}
      className="pdf-container"
    >
      <Document file={file} options={pdfDocumentOptions} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={isDesktop ? null : pdfContainerRect?.width}
            scale={scale}
            onRenderSuccess={onPageRenderSuccess}
            renderMode="canvas"
          />
        ))}
      </Document>
      {renderBottom && (typeof renderBottom === "function" ? renderBottom() : renderBottom)}
    </PDFStyled>
  );
}

export default PDF;

const PDFStyled = styled.div`
  .react-pdf__Page__canvas {
    margin: 0 auto;
    border-radius: 5px;
  }
`;
